import React from 'react';


class Aside extends React.Component {
  render() {
    return (
      <aside className="aside-menu">
        Aside Menu
      </aside>
    )
  }
}

export default Aside;



// WEBPACK FOOTER //
// ./src/components/Aside/Aside.js